import { InputSkeleton, TableSkeleton } from '@/_components';
import { CardContainer, FormLayout, SectionHeadingSkeleton } from '@/_containers';

export default function Loading() {
  return (
    <>
      <CardContainer>
        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
        </FormLayout>
      </CardContainer>
      <CardContainer>
        <SectionHeadingSkeleton withIcon={false} />
        <TableSkeleton numberOfColumns={5} maxRows={10} containerClassName="mt-4" equalWidthCols />
      </CardContainer>
    </>
  );
}
